import { TAgentService } from '@/models/agents';
import {
  ActionIcon,
  Button,
  Table,
  Text,
  TextInput,
  Textarea,
} from '@mantine/core';
import { PiTrashBold } from 'react-icons/pi';

export default function AgentServiceDeliverables({
  deliverables,
  onChange,
}: {
  deliverables: TAgentService['deliverables'];
  onChange: (deliverables: TAgentService['deliverables']) => void;
}) {
  return (
    <>
      {deliverables.length ? (
        <>
          <Text fw={500} size="xs" mt="md">
            Deliverables
          </Text>
          <Text size="xs" mt="xs" c="dimmed">
            These are the deliverables that agent provides for this service,
            assuming that deliverables are sold as package, not separately. If
            there's 1 deliverable, it means service does not contain any other
            "included" services, except for itself. In that case, you should not
            use deliverables.
          </Text>
          <Table withRowBorders={false}>
            <Table.Tbody>
              {deliverables.map((d, i) => (
                <Table.Tr key={i}>
                  <Table.Td>
                    <TextInput
                      size="xs"
                      variant="filled"
                      value={d.title}
                      mb={5}
                      onChange={({ target }) => {
                        const newDeliverables = [...deliverables];
                        newDeliverables[i].title = target.value;
                        onChange(newDeliverables);
                      }}
                    />
                    <Textarea
                      size="xs"
                      variant="filled"
                      value={d.description || ''}
                      placeholder="Optional description"
                      onChange={({ target }) => {
                        const newDeliverables = [...deliverables];
                        newDeliverables[i].description = target.value;
                        onChange(newDeliverables);
                      }}
                    />
                  </Table.Td>
                  <Table.Td valign="top" w={0}>
                    <ActionIcon
                      variant="light"
                      color="red"
                      onClick={() => {
                        const newDeliverables = [...deliverables];
                        newDeliverables.splice(i, 1);
                        onChange(newDeliverables);
                      }}
                    >
                      <PiTrashBold />
                    </ActionIcon>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </>
      ) : null}

      <Button
        size="xs"
        variant="light"
        mt={'md'}
        onClick={() => {
          onChange([...deliverables, { title: '', description: '' }]);
        }}
      >
        Add deliverable
      </Button>
    </>
  );
}
